import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DynamicPriceDailyBreakdownComponent } from '@app/modules/calendar/components/dynamic-price-daily-breakdown/dynamic-price-daily-breakdown.component';
import { DynamicPricingUpsellInformation } from '@app/shared/interfaces/lib/dynamic-pricing.interface';
import { FunctionPipe } from '@app/shared/pipes/function/function.pipe';
import { UiModule } from '@app/ui';
import { MaterialModule } from '@app/ui/material.module';
import { BehaviorSubject } from 'rxjs';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { DynamicPricingPropertyErrorMobileModalComponent } from '@app/modules/calendar/components/dynamic-pricing-property-error-mobile-modal /dynamic-pricing-property-error-mobile-modal.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { firstValueFrom } from 'rxjs';

enum PriceComparisonResultEnum {
  OVERPRICED = 'overpriced',
  UNDERPRICED = 'underpriced',
  NEUTRAL = 'neutral',
}

@Component({
  standalone: true,
  selector: 'sbnb-dynamic-pricing-sidebar-breakdown',
  templateUrl: './dynamic-pricing-sidebar-breakdown.component.html',
  styleUrls: ['./dynamic-pricing-sidebar-breakdown.component.scss'],
  imports: [CommonModule, UiModule, MaterialModule, DynamicPriceDailyBreakdownComponent, FunctionPipe],
})
export class DynamicPricingSidebarBreakdownComponent implements OnChanges {
  showBreakdown = false;
  PRICE_COMPARISON_RESULT = PriceComparisonResultEnum;
  loading = false;
  public resetting = new BehaviorSubject<boolean>(false);

  @Input() dynamicPricingUpsellInformation: DynamicPricingUpsellInformation;

  @Output() useDynamicPricing = new EventEmitter<void>();
  @Output() previewDynamicPricing = new EventEmitter<void>();

  render: any = {};

  // to be in parity w/ propery-calendar mobile dimensions
  public isMobile$ = this.deviceDetectionService.observeBreakpoint('(max-width:  1278px)');
  constructor(private deviceDetectionService: DeviceDetectionService, private dialog: MatDialog) { }

  getPriceComparisonResult(currentPrice: number, futurePrice: number) {
    if (!currentPrice || !futurePrice) {
      return -1;
    }

    const percentageDifference = ((futurePrice - currentPrice) / currentPrice) * 100;

    if (percentageDifference > 10) {
      return PriceComparisonResultEnum.UNDERPRICED;
    } else if (percentageDifference < -10) {
      return PriceComparisonResultEnum.OVERPRICED;
    }
    return PriceComparisonResultEnum.NEUTRAL;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['dynamicPricingUpsellInformation'].currentValue &&
      changes['dynamicPricingUpsellInformation'].currentValue !==
        changes['dynamicPricingUpsellInformation'].previousValue
    ) {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    }
  }

  public resetToDynamicPricing() {
    this.resetting.next(true);
    this.useDynamicPricing.emit();
  }

  public presentMobileDPModal() {
    this.dialog.open(DynamicPricingPropertyErrorMobileModalComponent, {
      height: '100vh',
      width: '100vw',
      maxWidth: '100%',
      maxHeight: '100%',
      data: {
        propertyId: this.dynamicPricingUpsellInformation.propertyId,
      },
    });
  }
}
